'use client';

import { Layers, X } from 'lucide-react';
import { useTierSimulator } from '@/hooks/useTierSimulator';
import { TIER_DISPLAY } from '@/lib/licensing/types';

/**
 * Persistent banner shown at the top of the viewport while simulating a tier.
 * Mirrors the MasqueradeBanner pattern.
 */
export function TierSimulatorBanner() {
  const { isSimulating, simulatedTier, deactivateSimulation, loading } = useTierSimulator();

  if (!isSimulating || !simulatedTier) return null;

  const tierInfo = TIER_DISPLAY[simulatedTier];
  const displayName = tierInfo?.name ?? simulatedTier;

  return (
    <div className="sticky top-0 z-[59] bg-violet-950/80 border-b border-violet-500/30 backdrop-blur-sm">
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center gap-2 text-sm text-violet-200">
          <Layers className="w-4 h-4 text-violet-400 shrink-0" />
          <span>
            <span className="font-medium text-violet-100">Simulating tier:</span>{' '}
            {displayName}
          </span>
          <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-violet-500/20 text-violet-300 border border-violet-500/30">
            SIMULATOR
          </span>
        </div>
        <button
          onClick={deactivateSimulation}
          disabled={loading}
          className="flex items-center gap-1.5 px-3 py-1 text-xs font-medium text-violet-200 hover:text-white bg-violet-800/50 hover:bg-violet-700/60 rounded-md transition-colors disabled:opacity-50"
        >
          <X className="w-3.5 h-3.5" />
          End Simulation
        </button>
      </div>
    </div>
  );
}
